import { createFileRoute, notFound, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/settings/_admin/_disabled")({
  component: RouteComponent,

  beforeLoad: async ({ context }) => {
    throw notFound(); // TODO - remove this when route is implemented
  },
});

function RouteComponent() {
  return <Outlet />;
}
